export default __webpack_public_path__ + "static/media/content_tab04_2_02.65825ff0.png";